<!--
/*******************************************************************************
*@ 컴포넌트명   : managePayeesUpdateModal.vue
*@ 컴포넌트설명 : 자주쓰는계좌 수정 modal
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <modal-pop
    :opened.sync="opendAcnoInfoReg"
    :modalHeader="true"
    :modalFooter="true"
    title="MPAY-02-01-28-17"
  >
    <template #content>
      <div>
        <template
          v-if="lang == $config.LANG_KOR"
        >{{ /*예금주명이 등록된 계좌만 타행 이체 거래 가능합니다.*/ $t("MPAY-02-01-28-16") }}</template>
        <template v-else>
          <strong
            class="text-info-left"
          >{{ /*예금주명이 등록된 계좌만 타행 이체 거래 가능합니다.*/ $t("MPAY-02-01-28-16") }}</strong>
        </template>
      </div>
      <div>{{ /*예금주명이 등록된 계좌만 타행 이체 거래 가능합니다.*/ $t("MPAY-02-01-28-19") }}</div>
      <div class="account-info -type9">
        <div class="item">
          <div class="tit">{{ /* 입금은행 */ $t("MPAY-03-02-06-05") }}</div>
          <div class="dec">{{ mnrcvInfo.mnrcvOthrBnkName }}</div>
        </div>
        <div class="item">
          <div class="tit">{{ /*입금계좌번호*/ $t("MPAY-02-01-26-08") }}</div>
          <div class="dec">{{ mnrcvInfo.mnrcvAcno }}</div>
        </div>
        <div class="item">
          <div class="tit">{{ /*계좌 별명*/ $t("MPRS-02-01-03-05") }}</div>
          <div class="dec">{{ mnrcvInfo.mnrcvAcnAls }}</div>
        </div>
        <!-- <div class="item">
            <div class="tit">{{ /*송금방식*/ $t("MPAY-02-01-24-10") }}</div>
            <div
              class="dec"
            >{{ napasTrasaccInptPro2.tranDstCd == "03" ? $t("MPAY-02-01-18-05") : $t("MPAY-02-01-18-06") }}</div>
        </div>-->
      </div>
      <div class="form">
        <input-text
          ref="mnrcvDpstrName"
          id="mnrcvDpstrName"
          :value.sync="changeData.mnrcvDpstrName"
          labelI18n="MPRS-02-02-19-05"
          placeholder="MPRS-02-02-19-06"
          required
          :localeCase3="`${$config.SITECODE_OGHCM}`"
          :maxByte="40"
        />
      </div>
      <strong class="info-question">{{ /*위 예금주명으로 등록합니다.*/ $t("MPAY-02-01-28-18") }}</strong>
    </template>
    <template #footer>
      <button
        :class="['btn bottom positive', changeData.mnrcvDpstrName == ''? 'disabled':'']"
        @click="updateAcnoInfo"
      >{{ /* 확인 */ $t("MCOM-0000003") }}</button>
    </template>
  </modal-pop>
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
  props: {
    mnrcvInfo: Object,
    opendAcnoInfoReg: Boolean,
  },
  data() {
    return {
      changeData: {
        mnrcvDpstrName: "", //예금주명
      },
    };
  },
  computed: {
    ...mapFields(["lang"]),
  },
  methods: {
    updateAcnoInfo() {
      this.RBF0500B50Call();
    },
    /* API_RBF0500B50 호출 */
    RBF0500B50Call() {
      this.$post(
        "/customer/acn/MnrcyAcnRegiUpt",
        {
          dmndPageNo: "00000",
          pageLineCnt: "00000",
          inquryUserStupAcnDstcd2: "2",
          gridRowCnt: "00001",

          inDataGrid: [
            {
              inquryObaobDstcd: "2", //당타행구분코드 1:당행, 2:타행
              inquryAcno: this.mnrcvInfo.mnrcvAcno, //계좌번호
              inqurySerno: this.mnrcvInfo.mnrcvSerno, //일련번호
              inquryAcnAls: this.mnrcvInfo.mnrcvAcnAls, //계좌별명
              inquryDpstrName: this.changeData.mnrcvDpstrName, //예금주명
              inquryPrcssDstcd: "5", //처리구분코드 1:출금계좌등록, 2:입금계좌등록, ▷5:계좌번호변경, 6:계좌번호해지
            },
          ],
        },
        this.RBF0500B50Suc,
        this.RBF0500B50Fail,
      );
    },
    RBF0500B50Suc() {
      this.$emit("update:opendAcnoInfoReg", false);
      this.$emit("managePayeesUpdated", this.changeData);
    },
    RBF0500B50Fail() {
      this.$set(this.changeData, "mnrcvDpstrName", ""); //예금주명
      this.$emit("update:opendAcnoInfoReg", false);
    },
  },
};
</script>